import { render, staticRenderFns } from "./TaskFormInfo.vue?vue&type=template&id=a5878ca2&scoped=true&"
import script from "./TaskFormInfo.vue?vue&type=script&lang=ts&"
export * from "./TaskFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TaskFormInfo.vue?vue&type=style&index=0&id=a5878ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5878ca2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
